import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CacheBusterService {
  forceReload(): void {
    const baseUrl = window.location.origin + '/';
    window.location.href = `${baseUrl}?_=${Date.now()}`;
  }
}
